import React, { useEffect } from 'react';
import styles from './S1.module.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

import defaultVideo from './assets/video/videoSmartBook.mp4';
import mobileVideo from './assets/video/smartbookiaCelular.mp4';
import backgroundVideo from './assets/video/fondo4.mp4';

const VideoComponent = () => {
  useEffect(() => {
    AOS.init({ duration: 2000 });
    console.log('AOS initialized');
  }, []);


  return (
    <div className={styles.container}>
      <video className={styles.backgroundVideo} autoPlay loop muted playsInline>
        <source src={backgroundVideo} type="video/mp4" />
        Tu navegador no soporta el video.
      </video>
      <div className={styles.contentWrapper}>

        <div className={styles.videoTextContainer} data-aos="fade-up">
          <div className={styles.textContainer}>
            <h2 className={styles.title}>SmartBookIA</h2>
            <p className={styles.description}>
              ¿Alguna vez has deseado que tus libros digitales fueran tan inteligentes como tú? <br/><br/>
              ¡Tu deseo se ha hecho realidad con SmartbookIA! <br/><br/>
              Imagina un mundo donde tus libros no solo contienen información, sino que también interactúan contigo.
            </p>
          </div>
        </div>

        <div className={styles.videoContainer}>
          <video autoPlay loop muted className={`${styles.computerVideo} ${styles.defaultVideo}`}>
            <source src={defaultVideo} type="video/mp4" />
          </video>
          <video autoPlay loop muted className={`${styles.phoneVideo} ${styles.mobileVideo}`}>
            <source src={mobileVideo} type="video/mp4" />
          </video>
        </div>

      </div>
    </div>
  );
}

export default VideoComponent;